/**
 * Adds a value to a list, or takes it out if it is already there.
 *
 * What every chip row in the app does on a tap — filters, account
 * preferences, the genres and providers on a new film. It lived three times
 * over as a private copy, which is three places to fix if the selection ever
 * has to keep its order or compare by something other than identity.
 */
export function toggle<T>(values: readonly T[], value: T): T[] {
  return values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
}
